import { defineMessages } from 'react-intl';

const scope = 'axionoee.controls.sidebar';

export default defineMessages({
  lastUpdated: {
    id: `${scope}.version.popup.lastUpdated`,
    defaultMessage: 'Senast uppdaterad:',
  },
  noLoadsYet: {
    id: `${scope}.version.popup.noLoadsYet`,
    defaultMessage: "No loads yet", 
  }
})